"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconHeartSvg = function IconHeartSvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.875 2.153A3.986 3.986 0 1 0 2.042 7.58l5.573 5.083a.367.367 0 0 0 .52 0l5.573-5.083a3.986 3.986 0 1 0-5.833-5.426zm0 9.728L2.563 7.058a3.25 3.25 0 0 1 0-4.594 3.25 3.25 0 0 1 5.005.502c.146.219.468.219.614 0a3.252 3.252 0 0 1 5.006-.503 3.252 3.252 0 0 1 0 4.595z",
    fill: "#132122"
  }));
};

IconHeartSvg.defaultProps = {
  viewBox: "0 0 15 13",
  xmlns: "http://www.w3.org/2000/svg"
};

var IconHeart = function IconHeart(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray800' : _ref$color,
      measure = _ref.measure,
      rest = _objectWithoutProperties(_ref, ["color", "measure"]);

  return /*#__PURE__*/_react.default.createElement(_index.IconStyled, _extends({
    $color: color,
    $measure: measure
  }, rest), /*#__PURE__*/_react.default.createElement(IconHeartSvg, null));
};

IconHeart.displayName = 'IconHeart';
var _default = IconHeart;
exports.default = _default;